/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FlightSeatCapabilities } from "./FlightSeatCapabilities";
import {
  FlightSeatCapabilitiesFromJSON,
  FlightSeatCapabilitiesFromJSONTyped,
  FlightSeatCapabilitiesToJSON,
  FlightSeatCapabilitiesToJSONTyped,
} from "./FlightSeatCapabilities";

/**
 *
 * @export
 * @interface FlightSeatOption
 */
export interface FlightSeatOption {
  /**
   *
   * @type {FlightSeatCapabilities}
   * @memberof FlightSeatOption
   */
  capabilities?: FlightSeatCapabilities;
  /**
   *
   * @type {number}
   * @memberof FlightSeatOption
   */
  passengerIndex: number;
  /**
   *
   * @type {number}
   * @memberof FlightSeatOption
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof FlightSeatOption
   */
  currency: string;
  /**
   *
   * @type {string}
   * @memberof FlightSeatOption
   */
  selectionToken: string;
}

/**
 * Check if a given object implements the FlightSeatOption interface.
 */
export function instanceOfFlightSeatOption(
  value: object
): value is FlightSeatOption {
  if (!("passengerIndex" in value) || value["passengerIndex"] === undefined)
    return false;
  if (!("amount" in value) || value["amount"] === undefined) return false;
  if (!("currency" in value) || value["currency"] === undefined) return false;
  if (!("selectionToken" in value) || value["selectionToken"] === undefined)
    return false;
  return true;
}

export function FlightSeatOptionFromJSON(json: any): FlightSeatOption {
  return FlightSeatOptionFromJSONTyped(json, false);
}

export function FlightSeatOptionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightSeatOption {
  if (json == null) {
    return json;
  }
  return {
    capabilities:
      json["capabilities"] == null
        ? undefined
        : FlightSeatCapabilitiesFromJSON(json["capabilities"]),
    passengerIndex: json["passenger_index"],
    amount: json["amount"],
    currency: json["currency"],
    selectionToken: json["selection_token"],
  };
}

export function FlightSeatOptionToJSON(json: any): FlightSeatOption {
  return FlightSeatOptionToJSONTyped(json, false);
}

export function FlightSeatOptionToJSONTyped(
  value?: FlightSeatOption | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    capabilities: FlightSeatCapabilitiesToJSON(value["capabilities"]),
    passenger_index: value["passengerIndex"],
    amount: value["amount"],
    currency: value["currency"],
    selection_token: value["selectionToken"],
  };
}
